import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useStore, useQuery } from "../../store";
import { useI18n } from "../../i18n";
import { useStyles, useColors } from "../../ui";
import { PdfForm } from "../../components/PdfForm";
import { FORM_FIELDS } from "./formFields";
import { useAuth } from "../../auth";
import { db } from "../../db";
import { cases as casesTable } from "../../../../shared/src/schema";
import { eq } from "drizzle-orm";

export function CasePage() {
  const { id, eventId } = useParams<{ id: string; eventId?: string }>();
  const { t } = useI18n();
  const { openCase, online } = useStore();
  const styles = useStyles();
  const colors = useColors();
  const { user } = useAuth();

  const { data: caseRow } = useQuery(
    () => id ? db.select({ createdBy: casesTable.createdBy }).from(casesTable).where(eq(casesTable.id, id)).then((r) => r[0] ?? null) : Promise.resolve(null),
    [id],
  );

  // medicRole2 sees page 1 only, unless they created the case directly (direct admission)
  const maxPage = user?.role === "medicRole2" && caseRow?.createdBy !== user.userId ? 1 : undefined;

  // Re-run when `online` changes: on refresh, children effects fire before
  // StoreProvider's effect sets engineRef, so the first call is a no-op.
  // When the engine connects (`online` → true), this re-runs and succeeds.
  useEffect(() => {
    if (id) openCase(id).catch(() => {});
  }, [id, online]);

  if (!id)
    return (
      <div style={{ padding: "12px" }}>
        <p style={{ color: colors.textMuted }}>{t("case.dataMissing")}</p>
      </div>
    );

  return (
    <div style={styles.content}>
      <PdfForm caseId={id} fields={FORM_FIELDS} initialEventId={eventId} maxPage={maxPage} />
    </div>
  );
}
